module.exports = __webpack_public_path__ + "static/media/playnow.f3952497.png";